import { Card, CardContent, CardHeader } from "../../../../../components/ui/common/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../../../../../components/ui/common/table";
import {
  INGREDIENT_DETAILS_TABLE_CONTAINER_CLASS,
  INGREDIENT_DETAILS_TABLE_HEADER_ROW_CLASS,
  INGREDIENT_DETAILS_TABLE_ROW_CLASS
} from "../shared/tableStyles";

interface RelatedProductsTableProps {
  products: Array<Record<string, unknown>> | undefined;
}

/** "Ingredient Related Products" table — Tailwind rebuild of the legacy `CommonTable`/`IngredientViewProductCol` pairing. */
const RelatedProductsTable = ({ products }: RelatedProductsTableProps) => {
  if (!products || products.length === 0) return null;

  return (
    <Card className="tw-gap-3 tw-py-4">
      <CardHeader className="tw-px-4">
        <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground">
          Ingredient Related Products
        </span>
      </CardHeader>
      <CardContent className="tw-px-4">
        <div className={INGREDIENT_DETAILS_TABLE_CONTAINER_CLASS}>
          <Table>
            <TableHeader>
              <TableRow className={INGREDIENT_DETAILS_TABLE_HEADER_ROW_CLASS}>
                <TableHead>Product Name</TableHead>
                <TableHead>Unit Name</TableHead>
                <TableHead>Unit Size</TableHead>
                <TableHead>Unit Type</TableHead>
                <TableHead>EAN</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {products.map((data, index) => (
                <TableRow key={index} className={INGREDIENT_DETAILS_TABLE_ROW_CLASS}>
                  <TableCell>{(data.productName as string) || ""}</TableCell>
                  <TableCell>{(data.salesUnitName as string) || ""}</TableCell>
                  <TableCell>{(data.saleUnitSize as string) ?? ""}</TableCell>
                  <TableCell>{(data.salesUnitType as string) || ""}</TableCell>
                  <TableCell>{(data.salesUnitEAN as string) || ""}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default RelatedProductsTable;
